import { useSyncExternalStore } from 'react'
import { getKioskRole, type KioskRole } from '../utils/kioskDisplaySync'

/** Subscribe to sessionStorage role (updated at boot via AuthContext). */
function subscribeKioskRole(onStoreChange: () => void): () => void {
  if (typeof window === 'undefined') return () => {}
  const handler = () => onStoreChange()
  window.addEventListener('lts-kiosk-role-change', handler)
  window.addEventListener('storage', handler)
  return () => {
    window.removeEventListener('lts-kiosk-role-change', handler)
    window.removeEventListener('storage', handler)
  }
}

function getKioskRoleSnapshot(): KioskRole | null {
  return getKioskRole()
}

export function useKioskRole(): KioskRole | null {
  return useSyncExternalStore(subscribeKioskRole, getKioskRoleSnapshot, () => null)
}

export function isKioskRole(role: KioskRole | null): role is KioskRole {
  return role === 'controller' || role === 'display' || role === 'regular'
}

export function isKioskSettingsHost(role: KioskRole | null): boolean {
  return role === 'controller' || role === 'regular'
}
